// import 'rxjs/Rx'; // adds ALL RxJS statics & operators to Observable

// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators we need for THIS app.

// Statics
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/interval';


// Operators
//import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/retry';
//import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/last';



// WEBPACK FOOTER //
// ./src/app/rxjs-operators.ts